import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BlogService } from '../../services/blog.service';
import { BlogModel } from '../../models/blog.model';

@Component({
  selector: 'app-page-blog-detail',
  templateUrl: './page-blog-detail.component.html',
  styleUrls: ['./page-blog-detail.component.css']
})

/**
 * Page Blog-Detail Component
 */
export class PageBlogDetailComponent implements OnInit {
Id = 0;
currentLang = localStorage.getItem('lang') || 'ar';
      // Set Topbar Option
  Menuoption = 'center';
  Settingicon = true;
  constructor(private route: ActivatedRoute,private blogService: BlogService){
     this.Id = +route.snapshot.paramMap.get("Id")!;
  }
blog:BlogModel = {};
  ngOnInit(): void {
        if(this.Id > 0){
  this.blogService.getById(this.Id).subscribe((res: any) => {
        this.blog = res;
       
      });
    }
  }

}
